import moment from "moment";

export const estaExpirada = (propuesta) => {
  if (!propuesta.exp) return false;
  return moment().unix() > propuesta.exp;
};

export const diasRestantes = (propuesta) => {
  if (!propuesta.exp) return null;
  const diff = moment.unix(propuesta.exp).diff(moment(), "days");
  return Math.max(0, diff);
};

export const fechaExpiracion = (propuesta, formato = "string") => {
  if (!propuesta.exp) return null;

  const momentDate = moment.unix(propuesta.exp);

  if (formato === "moment") {
    return momentDate;
  }

  return momentDate.format("DD/MM/YYYY");
};

export const estaProximaAExpirar = (propuesta) => {
  const dias = diasRestantes(propuesta);
  return dias !== null && dias <= 3 && dias > 0;
};
